import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      <div className="relative flex-1 flex items-end p-8 md:p-14 min-h-[400px] lg:min-h-[550px] overflow-hidden bg-accent-50">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20flat%20lay%20composition%20with%20neutral%20toned%20clothing%20including%20sand%20colored%20linen%20blazer%20cream%20cashmere%20sweater%20and%20tan%20leather%20accessories%20arranged%20on%20warm%20terracotta%20tiled%20surface%20soft%20afternoon%20sunlight%20from%20upper%20right%20creating%20gentle%20shadows%20clean%20editorial%20aesthetic%20high%20detail%20harmonious%20composition%20no%20text%20no%20logos%20Mediterranean%20style&width=900&height=700&seq=cta-fashion-v3&orientation=portrait"
            alt="Kakobuy moda"
            title="Kakobuy Spreadsheet – moda i styl w zasięgu ręki"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 via-background-100/30 to-transparent"></div>
        </div>
        <div className="relative z-10">
          <span className="text-xs font-semibold text-foreground-500 uppercase tracking-widest">
            Kakobuy Spreadsheet
          </span>
          <h2 className="mt-2 text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-900 leading-none">
            {t("cta_title_line1")}
            <br />
            {t("cta_title_line2")}
          </h2>
        </div>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center p-8 md:p-14 bg-white text-center min-h-[400px] lg:min-h-[550px]">
        <div className="max-w-md">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-tight">
            {t("cta_title_line1")}
            <br />
            {t("cta_title_line2")}
          </h2>
          <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
            {t("cta_description")}
          </p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="mt-8 inline-flex items-center justify-center gap-2 px-10 py-4 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span>{t("cta_button")}</span>
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}